import React from "react";
import { Box, Typography, List, ListItem, ListItemIcon } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface SummaryItem {
  label: string;
  value: string;
}

interface SummaryWithIconsProps {
  icons?: React.ReactNode[];
  summaryItems?: SummaryItem[];
  description?: string | string[]; // Accept single line or list
}

const SummaryWithIcons: React.FC<SummaryWithIconsProps> = ({
  icons = [],
  summaryItems = [],
  description,
}) => {
  const hasIcons = icons.length > 0;
  const hasSummary = summaryItems.length > 0;

  return (
    <Box>
      {/* Icons Row */}
      {hasIcons && (
        <Box display="flex" justifyContent="center" gap={1} mb={2}>
          {icons.map((icon, idx) => (
            <Box key={idx}>{icon}</Box>
          ))}
        </Box>
      )}

      {/* Summary Key-Value Pairs */}
      {hasSummary && (
        <Box mb={2}>
          {summaryItems.map((item, idx) => (
            <Box key={idx} display="flex" mb={0.5}>
              <Typography
                sx={{
                  color: "rgba(69, 70, 78, 1)",
                  fontFamily: "Inter",
                  fontWeight: 700,
                  fontSize: "14px",
                  width: 80,
                  flexShrink: 0,
                  textAlign: "left",
                }}
              >
                {item.label}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(110, 112, 121, 1)",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {/* Description: Single line or list */}
      {description && (
        <Box
          p={1.5}
          sx={{
            backgroundColor: "#f6fafd",
            borderRadius: 1
          }}
        >
          {Array.isArray(description) ? (
            <>
              <Typography
                sx={{
                  color: "rgba(110, 112, 121, 1)",
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "14px"
                }}
              >
                {description[0]}
              </Typography>
              <List dense sx={{ pl: 2 }} className="desciption-list">
                {description.slice(1).map((point, index) => (
                  <ListItem key={index} disableGutters sx={{ pl: 0, pt: 0, pb: 0 }}>
                    <ListItemIcon sx={{ minWidth: "20px" }}>
                      <FiberManualRecordIcon sx={{ fontSize: "6px", color: "rgba(110, 112, 121, 1)" }} />
                    </ListItemIcon>
                    <Typography
                      sx={{
                        color: "rgba(110, 112, 121, 1)",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      {point}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </>
          ) : (
            <Typography
              sx={{
                color: "rgba(110, 112, 121, 1)",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "14px",
                textAlign: "left",
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default SummaryWithIcons;